<template>
  <el-menu-item :index="menu.path">
    <i v-if="menu.icon" :class="`fa fa-${menu.icon}`"></i>
    <span slot="title">{{ menu.title || '未命名菜单' }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'SideSubmenuItem',
  props: {
    menu: {
      type: Object,
      required: true
    }
  }
}
</script>
